export enum ArticleCategoryRouteName {
    Index = 'system.article.categories.index',
    Create = 'system.article.categories.create',
    Edit = 'system.article.categories.edit',
}

export default {
    path: 'article-categories',
    name: ArticleCategoryRouteName.Index,
    component: () => import('@/views/system/article-category/Index.vue'),
    meta: {
        auth: true,
        label: 'Article Categories',
        icon: 'fal fa-folder-tree fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-categories',
    },
    children: [
        {
            path: 'create',
            name: ArticleCategoryRouteName.Create,
            component: () => import('@/views/system/article-category/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Category',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
        {
            path: ':categoryUuid/edit',
            name: ArticleCategoryRouteName.Edit,
            component: () => import('@/views/system/article-category/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Category',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
    ],
}
